import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import erm from "../Images/erm.jpg";
import SEO from "../components/SEO";   

export default function Electronics() {
  return (
    <>
      <SEO  // 
        title="AI ERP & CRM for Electronics Industry | EnteliPro"
        description="EnteliPro offers AI-powered ERP and CRM solutions for electronics manufacturers and distributors. Optimize inventory, supply chain, and customer relationships with intelligent automation."
        keywords="Electronics ERP Software, AI CRM for Electronics, Manufacturing Management, Supply Chain Optimization, Inventory Management, Electronics Distribution CRM"
        canonical="https://www.entelipro.com/Electronics"
        ogImage="https://www.entelipro.com/static/media/erm.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  {/*  - <a> to <Link> */}
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Electronics Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={erm}
                  alt="EnteliPro AI ERP for Electronics Manufacturing and Distribution"   
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>  
                  AI ERP & CRM for Electronics Industry
                </h1>
                <p className="para">
                  Electronic Customer Relationship Management (E-CRM) is an
                  integrated online sales, marketing, and service strategy that
                  is used to identify, attract and retain an organization's
                  customers. EnteliPro delivers intelligent ERP solutions tailored
                  for electronics manufacturers and distributors.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      It describes improved and increased communication between
                      an organization and its clients by creating and enhancing
                      customer interaction through innovative technology.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      E-CRM software provides profiles and histories of each
                      interaction the organization has with its customers,
                      making it an important tool for all small and medium
                      businesses in the electronics sector.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies electronics-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Business Benefits of AI ERP for Electronics Industry</h3>
              <p className="para">
                Implementation of an ERP system enables an electronics organization to
                streamline processes and provide sales, marketing, and service
                personnel with better, more complete customer information. The
                result is that ERP allows organizations to build more
                profitable customer relationships and decrease operating costs.
              </p>
              <br />
              <p className="para">
                Businesses that strategize and implement an ERP solution can
                align their processes around technology to effectively deliver a
                seamless, high-quality customer experience across all channels.
                Customers have the power to help themselves through online
                personalized services that are made available on demand. The
                Internet provides a simple and ideal medium where customers can
                get information from websites, buy products and find answers
                using FAQ sections, forums, or chat rooms.
              </p>
              <br />
              <p className="para">
                The benefits of AI ERP for Electronics Industry include the following:
                <br />
                <br />
                1. Improved customer relations, service, and support
                <br />
                <br />
                2. Matching the customers' behavior with suitable offers
                <br />
                <br />
                3. Increased customer satisfaction and loyalty
                <br />
                <br />
                4. Greater efficiency and cost reduction
                <br />
                <br />
                5. Increased business revenue
              </p>
            </div>
            <br /> <br />
            <div className="left-text">
              <h3>Key Features of AI ERP for Electronics Businesses</h3>
            </div>
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Customer Management</h4>
                  <p className="para">
                    Provides access to all customer information including
                    inquiry status and correspondence.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Knowledge Management</h4>
                  <p className="para">
                    A centralized knowledge base that handles and shares
                    customer information.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Back-End Integration</h4>
                  <p className="para">
                    Blends with other systems such as billing, inventory through
                    relevant customers contact points such as websites and call
                    centers.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}